import { CardBody } from "reactstrap";
import Profit from "./Profit";
import RightSide from "./RightSide";

const TotalSoldCardBody = () => {
  return (
    <CardBody>
      <Profit />
      <RightSide />
    </CardBody>
  );
};

export default TotalSoldCardBody;
